<template>
  <div class="page flex-col">
    <!-- PPT播放容器 -->
    <div
      v-if="showPptViewer"
      class="ppt_viewer flex-col flex-center"
    >
      <button
        @click="exitFullscreen"
        class="close_button"
      >
        关闭（X）
      </button>
      <div
        v-if="isLoading"
        class="loading_text"
      >
        <div>加载中...</div>
      </div>
      <iframe
        ref="pptViewerRef"
        :src="pptViewerUrl"
        class="ppt_iframe"
        allowfullscreen
        frameborder="0"
        @load="enterFullscreen"
        @error="handlePptError"
      ></iframe>
    </div>

    <div class="container flex-row">
      <!-- 主体 -->
      <div class="container_page flex-col">
        <div class="header_container flex-row">
          <BackButton
            :customClick="handleBackClick"
            class="back_button"
          />

          <Dropdown
            class="select_item"
            :options="academicOptions"
            placeholder="学年"
            @selection-change="handleYearSelection"
          />

          <Dropdown
            class="select_item"
            :options="classOptions"
            placeholder="班级"
            @selection-change="handleClassSelection"
          />

          <div class="enter_classroom_button flex-row">
            <img
              class="classroom_icon"
              referrerpolicy="no-referrer"
              src="../../assets/teacher/records/FigmaDDSSlicePNG98f53db76e2ede14db2204e493c15fa6.png"
            />
            <span class="enter_class_text">进入课堂模式</span>
          </div>
          <div
            class="play_ppt_button flex-row justify-between"
            @click="playPpt"
          >
            <img
              class="ppt_play_icon"
              referrerpolicy="no-referrer"
              src="../../assets/teacher/records/FigmaDDSSlicePNG83a7c88c83171a0e1c98aab755451a6b.png"
            />
            <span class="play_ppt_text">播放PPT</span>
          </div>
        </div>

        <div class="teacher_menu_container flex-row">
          <TeacherMenu />
        </div>

        <div class="lesson_wrapper flex-row">
          <span class="lesson_title">{{ lessonName }}</span>
        </div>

        <div class="content_box flex-row">
          <div class="main_section flex-col">
            <div class="student_stats_container flex-row">
              <span class="total_students_text">{{ total }}位学生</span>
              <div class="not_completed_indicator flex-col"></div>
              <span class="not_completed_text">未完成</span>
              <div class="attempted_indicator flex-col"></div>
              <span class="attempted_text">已尝试</span>
              <div class="completed_indicator flex-col"></div>
              <span class="completed_text">已完成</span>
              <img
                class="pagination_prev_icon"
                referrerpolicy="no-referrer"
                src="../../assets/teacher/records/FigmaDDSSlicePNGd4c8b146c5e977ba18d058cd878be396.png"
                @click="handleClickPage(-1)"
              />
              <span class="pagination_text"
                >第{{ currentPage }}/{{ Math.ceil(total / pageSize) }}页</span
              >
              <img
                class="pagination_next_icon"
                referrerpolicy="no-referrer"
                src="../../assets/teacher/records/FigmaDDSSlicePNG909fa7b2d82f34f9422697337d76c62a.png"
                @click="handleClickPage(1)"
              />
            </div>
            <div class="student_records_table flex-col">
              <div class="records_header_row flex-col">
                <div class="flex-row">
                  <span class="id_label">ID</span>
                  <span class="name_label">姓名</span>
                  <!-- <img
                    class="thumbnail_5"
                    referrerpolicy="no-referrer"
                    src="../../assets/teacher/records/FigmaDDSSlicePNG4d6543244ff7bb16112d461d613f5059.png"
                  /> -->
                  <span class="task_label">任务</span>
                </div>
                <div class="header_block flex-col">
                  <div class="header_separator flex-col"></div>
                </div>
              </div>
              <div
                class="student_row flex-row"
                :class="{
                  'even-row': index % 2 === 0,
                }"
                v-for="(item, index) in loopData"
                :key="index"
              >
                <span class="student_id">{{ item.studentId }}</span>
                <span class="student_name">{{ item.studentName }}</span>
                <div class="task_status_wrapper flex-row justify-center">
                  <div
                    class="status_wrapper flex-col"
                    :class="{
                      status_grey: block.statu === -1,
                      status_yellow: block.statu === 0,
                      status_green: block.statu === 1,
                    }"
                    @click="
                      handleClickTask(
                        idx + 1,
                        block.taskId,
                        item.studentId,
                        item.studentName,
                        block.statu
                      )
                    "
                    v-for="(block, idx) in item.taskStatuDetail"
                    :key="idx"
                  >
                    <span
                      class="task_number_grey"
                      v-if="block.statu === -1"
                      >{{ idx + 1 }}</span
                    >
                    <span
                      class="task_number"
                      v-else
                      >{{ idx + 1 }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 任务记录弹窗 -->
    <TaskRecordsDialog
      :visible="showPop"
      :lesson-id="lessonId"
      :task-id="taskId"
      :student-id="studentId"
      :index="taskIndex"
      :answer-info="answerInfo"
      @update-visible="showPop = false"
    />
    <!-- end 任务记录弹窗 -->
  </div>
</template>
<script setup>
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"

import { ref, onMounted, onUnmounted } from "vue"

import Dropdown from "@/components/teacher/Dropdown.vue"
import TeacherMenu from "@/components/teacher/TeacherMenu.vue"
import BackButton from "@/components/teacher/BackButton.vue"
import TaskRecordsDialog from "@/components/dialog/TaskRecordsDialog.vue"
import alovaInstance from "@/utils/alova"

const route = useRoute()
const store = useStore()
const router = useRouter()

const lessonName = ref("")
const academicOptions = ref([])
const classOptions = ref([])
const academicYear = ref("")
const classId = ref(-1)
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loopData = ref([])

const showPop = ref(false)
const lessonId = ref("")
const taskId = ref("")
const studentId = ref("")
const taskIndex = ref(-1)
const answerInfo = ref({})

const handleClickTask = async (
  task_index,
  task_id,
  student_id,
  studentName,
  statu
) => {
  lessonId.value = route.query.lessonId
  taskId.value = task_id
  studentId.value = student_id
  taskIndex.value = task_index
  try {
    const response = await alovaInstance.Post("/Record/GetAnswerInfo", {
      lessonId: lessonId.value,
      taskId: taskId.value,
      studentId: studentId.value,
    })
    // console.log(response)
    if (response.code === 1000) {
      answerInfo.value = response.data
      answerInfo.value.studentName = studentName
      answerInfo.value.statu = statu
      showPop.value = true
    } else {
      showPop.value = false
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
}

const showPptViewer = ref(false)
const pptViewerUrl = ref("")
const isLoading = ref(false)
const pptViewerRef = ref(null)
const playPpt = () => {
  let url = store.state.lessonUrl
  if (url) {
    // 使用Office Online Viewer预览PPT
    isLoading.value = true
    showPptViewer.value = true

    pptViewerUrl.value = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
      url
    )}`
  } else {
    alert("请提供有效的PPT链接")
  }
}

// 全屏控制函数
const enterFullscreen = () => {
  isLoading.value = false
  const viewer = pptViewerRef.value
  if (!viewer) return
  if (viewer.requestFullscreen) {
    viewer.requestFullscreen()
  } else if (viewer.mozRequestFullScreen) {
    viewer.mozRequestFullScreen()
  } else if (viewer.webkitRequestFullscreen) {
    viewer.webkitRequestFullscreen()
  } else if (viewer.msRequestFullscreen) {
    viewer.msRequestFullscreen()
  }
}

const exitFullscreen = () => {
  showPptViewer.value = false
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

const handlePptError = () => {
  alert("PPT加载失败，请检查链接是否有效")
  exitFullscreen()
}

// 监听全屏状态变化
const handleFullscreenChange = () => {
  if (!document.fullscreenElement) {
    showPptViewer.value = false
  }
}

onMounted(async () => {
  document.addEventListener("fullscreenchange", handleFullscreenChange)
  lessonName.value = store.getters.getLessonName

  try {
    const response = await alovaInstance.Post("/Class/GetAllAcademic")
    if (response.code === 1000) {
      academicOptions.value = response.data
    } else {
      alert("获取数据失败：" + response.message)
    }

    const allClass = await alovaInstance.Post("/Class/GetAllClass")
    if (allClass.code === 1000) {
      // console.log(allClass.data)
      classOptions.value = []
      for (let i = 0; i < allClass.data.length; i++) {
        classOptions.value.push({
          label: allClass.data[i].class_name,
          value: allClass.data[i].id,
        })
      }
    } else {
      alert("获取数据失败：" + allClass.message)
    }

    handleSelection()
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

onUnmounted(() => {
  document.removeEventListener("fullscreenchange", handleFullscreenChange)
})

const handleYearSelection = (year) => {
  // console.log("Selected year:", year)
  academicYear.value = year
  handleSelection()
}

const handleClassSelection = (value) => {
  // console.log("Selected class:", value)
  classId.value = value
  handleSelection()
}

const handleSelection = async () => {
  try {
    const response = await alovaInstance.Post(
      "/Record/GetLessonTaskCompletedStatu",
      {
        lessonId: route.query.lessonId,
        academicYear: academicYear.value,
        classId: classId.value,
        pageIndex: currentPage.value,
        pageSize: pageSize.value,
      }
    )
    // console.log(response)
    if (response.code === 1000 && response.data != null) {
      loopData.value = response.data.studentRecordStatuInfoList
      // loopData.value = loopData.value.concat(loopData.value).concat(loopData.value)
      total.value = response.data.totalCount
    } else if (response.code === 1000 && response.data == null) {
      loopData.value = []
      total.value = 0
      alert("没有符合条件的学生")
    } else {
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
}

const handleClickPage = (page) => {
  currentPage.value += page
  if (currentPage.value < 1) {
    currentPage.value = 1
  } else if (currentPage.value > Math.ceil(total.value / pageSize.value)) {
    currentPage.value = Math.ceil(total.value / pageSize.value)
  } else {
    return
  }
  handleSelection()
}

const handleBackClick = () => {
  router.push({
    name: "TeacherCourse",
    query: { 
      courseName: store.state.courseName,
      courseId:  store.state.courseId,
    },
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: rgba(234, 238, 242, 1);
}

.container {
  width: 100%;
  height: auto;
}

.container_page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 84.6875vw;
  height: auto;
  overflow: hidden;
}

.header_container {
  width: 80.6771vw;
  height: 3.4375vw;
  margin: 0.8854vw 0 0 1.5vw;
}

.classroom_icon {
  width: 1.0417vw;
  height: 1.0417vw;
  margin: 0.8333vw 0 0 1.3021vw;
}

.play_ppt_button {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 0.2083vw;
  width: 7.7604vw;
  height: 2.7083vw;
  margin: 0.7292vw 0 0 1.56vw;
  cursor: pointer;
}

.enter_classroom_button {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 0.2083vw;
  width: 10.1562vw;
  height: 2.7083vw;
  margin: 0.7812vw 0 0 33.4vw;
  cursor: pointer;
  visibility: hidden;
}

.ppt_play_icon {
  width: 1.0417vw;
  height: 1.0417vw;
  margin: 0.8333vw 0 0 1.25vw;
}

.play_ppt_text {
  width: 3.9062vw;
  height: 1.0417vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.0417vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
  margin: 0.7812vw 1.25vw 0 0;
}

.teacher_menu_container {
  width: 24.4792vw;
  height: 1.6667vw;
  margin: 0 0 0 1.5vw;
}

.enter_class_text {
  width: 6.25vw;
  height: 1.0417vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.0417vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
  margin: 0.7812vw 1.25vw 0 0.3125vw;
}

.lesson_wrapper {
  width: 5.8854vw;
  height: 1.3542vw;
  margin: 2vw 0 0 1.5vw;
}

.lesson_title {
  width: 5.8854vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
}

.content_box {
  width: 82.0312vw;
  height: auto;
  margin: 1.8229vw 0 0 1.5vw;
}

.main_section {
  width: 80.6771vw;
  height: auto;
}

.student_stats_container {
  width: 79.0625vw;
  height: 1.3542vw;
  margin-left: 0.0521vw;
}

.total_students_text {
  width: 3.75vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
}

.not_completed_indicator {
  background-color: rgba(160, 174, 188, 1);
  border-radius: 50%;
  width: 1.0417vw;
  height: 1.0417vw;
  margin: 0.1562vw 0 0 28.5vw;
}

.not_completed_text {
  width: 1.6667vw;
  height: 1.0938vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.8333vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.8333vw;
  margin: 0.1562vw 0 0 0.4167vw;
}

.attempted_indicator {
  background-color: rgba(244, 164, 51, 1);
  border-radius: 50%;
  width: 1.0417vw;
  height: 1.0417vw;
  margin: 0.1562vw 0 0 2.5vw;
}

.attempted_text {
  width: 2.5vw;
  height: 1.0938vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.8333vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.8333vw;
  margin: 0.15625vw 0 0 0.4167vw;
}

.completed_indicator {
  background-color: rgba(85, 195, 157, 1);
  border-radius: 50%;
  width: 1.0417vw;
  height: 1.0417vw;
  margin: 0.1562vw 0 0 2.4479vw;
}

.completed_text {
  width: 2.5vw;
  height: 1.0938vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.8333vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.8333vw;
  margin: 0.15625vw 0 0 0.4167vw;
}

.pagination_prev_icon {
  width: 1.3021vw;
  height: 1.25vw;
  margin: 0.04vw 0 0 24vw;
  cursor: pointer;
}

.pagination_next_icon {
  width: 1.3021vw;
  height: 1.25vw;
  margin-top: 0.04vw;
  cursor: pointer;
}

.pagination_text {
  width: 3.8021vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
  margin-left: 0.3125vw;
  margin-top: 0.1vw;
}

.student_records_table {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0.8333vw;
  position: relative;
  width: 80.6771vw;
  height: auto;
  min-height: 30vw;
  margin-top: 0.6771vw;
  padding-bottom: 1vw;
}

.records_header_row {
  width: 42.3958vw;
  height: 3.85vw;
  margin: 0 0 0 6.5vw;
  padding-top: 1.5vw;
}

.id_label {
  width: 2.0833vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
}

.header_block {
  width: auto;
  height: auto;
  margin-left: -6.5vw;
}

.header_separator {
  background-color: rgba(217, 217, 217, 1);
  width: 80.6771vw;
  height: 0.1042vw;
  margin: 0.8854vw 0 0 0vw;
}

.name_label {
  width: 2.0833vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
  margin-left: 11.4583vw;
}

.task_thumbnail {
  width: 1.0417vw;
  height: 1.0417vw;
  margin: 1.1979vw 0 0 0.4167vw;
}

.task_label {
  width: 2.0833vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(112, 119, 126, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
  margin-left: 28.6vw;
}

.student_row {
  background-color: rgba(255, 255, 255, 1);
  width: 80.6771vw;
  height: 4.1667vw;
  margin-top: 0;
}

.student_row:hover {
  background-color: rgba(205, 230, 255, 1);
}

.even-row {
  background-color: rgba(247, 251, 255, 1);
}

.student_id {
  width: 0.5729vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.9375vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.9375vw;
  margin: 1.5vw 0 0 6.7708vw;
}

.student_name {
  width: 10vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.9375vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.5vw 0 0 12.8vw;
}

.task_status_wrapper {
  width: 58vw;
  margin-left: -7.5vw;
}

.status_wrapper {
  border-radius: 3.2292vw;
  height: 2.6042vw;
  width: 2.6042vw;
  margin: 0.7812vw 0 0 0.5vw;
  cursor: pointer;
}

.status_grey {
  background-color: rgba(234, 238, 242, 1);
}

.status_yellow {
  background-color: rgba(244, 164, 51, 1);
}

.status_green {
  background-color: rgba(85, 195, 157, 1);
}

.task_number {
  width: 2.6vw;
  height: 1.6667vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.6vw 0 0 0;
}

.task_number_grey {
  width: 2.6vw;
  height: 1.6667vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.6vw 0 0 0;
}

.ppt_viewer {
  position: relative;
}

.close_button {
  position: relative;
  width: auto;
  height: auto;
}

.loading_text {
  position: relative;
  width: auto;
  height: auto;
  text-align: center;
}

.ppt_iframe {
  position: relative;
  width: auto;
  height: auto;
  border: 0;
}

.back_button {
  margin-right: 1.5vw;
}

.select_item {
  margin: 0.05vw 0 0 1.25vw;
}
</style>
